export default "__VITE_ASSET__BslZXfPs__"